import React, {Component, PropTypes} from 'react'
import {browserHistory} from 'react-router'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import * as actions from '../../actions'
import {api, domen} from '../../config.js'
import Menu from '../todayTask/Menu'
import HeaderTask from './HeaderTask'
import CalendarList from '../todayTask/CalendarList'
import MobileLeftMenu from './MobileLeftMenu'
import CSSModules from 'react-css-modules'
import styles from './layout.css'
import CalendarLoader from '../componentKit2/CalendarLoader'
import LoginValidationFormWrapper from '../profile/LoginValidationFormWrapper'
import LoadingView from '../componentKit/LoadingView'
import {Link} from 'react-router'
import MiniChat from '../Chat/MiniChat'
import classNames from 'classnames';
import cookie from "react-cookie";
/**
 *  Компонент Layout.
 *
 *
 */

class Layout extends Component {

  static propTypes = {
    profileData: PropTypes.object,
    selectedTaskDay: PropTypes.string.isRequired,
    pageNumber: PropTypes.number,
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const {dispatch, pageNumber, fetchTaskDayIfNeeded, selectedTaskDay, sign, location} = this.props;

    dispatch({type: 'SET_MENU_LIST', index: pageNumber})
    if(sign.isRegistered){
      fetchTaskDayIfNeeded(selectedTaskDay)
    }
		this.sengLogPageView(location)
  }



  componentWillReceiveProps(nextProps){
    const {fetchTaskDayIfNeeded, selectedTaskDay, sign} = this.props

    if(nextProps.sign.isRegistered !== sign.isRegistered){
      if(nextProps.sign.isRegistered){
        fetchTaskDayIfNeeded(selectedTaskDay)
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname){
			this.sengLogPageView(nextProps.location);
    }
  }

	sengLogPageView(location) {
		const urls = location.pathname.split('/');
		const url = location.pathname === '/' ? 'smm' : urls[1];
		const params = urls[2] ? urls[2] : null;
		const authToken =  cookie.load('token');

		if(!authToken) {
			return;
		}


		const payload = {
			authToken: authToken,
			data: {
				url,
				parameters: params ? params : null
			}
		};
		return fetch(`${api}/data/log-pageView`, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: JSON.stringify(payload)
		})
			.then(response => {
				return response.json()
			})
			.catch(console.error)
	}

  render() {
   const {
      userInfo, setTypeId, taskDay, errorModal, loadingModal, changeChatType, clearRenderChat, setAuth, params, pageNumber,setToken,
      showMobileLeftMenu, showLeftMenu, chats, setUserProfile, setSimpleRegs, isLoadSmm, hideLeftMenu, menuList, calendarLoadSlow, prevSeasons, smm, sign,
    } = this.props
    const {isRegistered, isSimpleRegs} = sign
    const isEmpty = !taskDay || !taskDay.data || taskDay.data.length === 0
    const {firstName, lastName, program, photo, gender, role} = userInfo.data
    let calendar, id
    const isAlfa = domen.isAlfa
    const isUnipro = domen.isUnipro

    if (isAlfa) {
      document.body.style.backgroundColor = "#f9f0f0"
    }
    if (isUnipro) {
      document.body.style.backgroundColor = "#dbe9f2"
    }

    if(!isEmpty){
      calendar= taskDay.data[0].calendar
      id = taskDay.data[0].id
    }
    if(smm && !isLoadSmm){
      return (<LoadingView  isUnipro={isUnipro} title="Загружается..."/>)
    }

    const sidebar =
      <div className={styles.gridCellLayoutMenu14}>
        { userInfo.data.role === 4 && isRegistered && isSimpleRegs &&
        <button className={styles.btnAction} onClick={() => {
          browserHistory.push('/signup/params')
        }}>
          Принять участие
        </button>
        }
      <div className={classNames(styles.gridLayoutMenuInner, {
        [styles.hidden]: userInfo.data.role === 4 && isRegistered
      })}>
        {
          smm && !isRegistered  ?
            <LoginValidationFormWrapper
                smm={true}
                setAuth={setAuth}
                setSimpleRegs={setSimpleRegs}
                setUserProfile={setUserProfile}
                setToken={setToken}
                errorModal={errorModal}
                loadingModal={loadingModal}
            /> : null
        }
        {isRegistered ? <Menu
          fullName={`${firstName} ${lastName}`}
          dayId={id}
          unReadMsgs={chats.unReadMsgs}
          prevSeasons={prevSeasons}
          program={program}
          gender={gender}
        />: null}

        {!isEmpty  && isRegistered ?
          !calendarLoadSlow
          ? <CalendarList
            calendar={calendar}
            dayId={id} role={role}
            privateChatId={actions.PRIVATE_CHAT_ID}
            setTypeId={setTypeId}
            changeChatType={changeChatType}
            clearRenderChat={clearRenderChat}
          />
          : <CalendarLoader/> : null
        }

      </div>
    </div>

    return (
      <div id='layout' className={styles.layout}>
        <HeaderTask
          program={program}
          showLeftMenu={showLeftMenu}
          fullName={firstName && lastName ? `${firstName} ${lastName}` : 'Гость'}
          avatar={photo}
          setAuth={setAuth}
          setSimpleRegs={setSimpleRegs}
          isSimpleRegs={isSimpleRegs}
          smm={smm}
        />

        { showMobileLeftMenu && isRegistered &&
        <MobileLeftMenu
          dayId={id}
          isRegistered={isRegistered}
          hideMenu={hideLeftMenu}
          userInfo={userInfo}
          isSimpleRegs={isSimpleRegs}
        />
        }

        {!isEmpty && pageNumber !== 5 && isRegistered && !isSimpleRegs && !window.mobilecheck() && !window.mobileAndTabletcheck() &&
          <MiniChat params={params} taskDay={taskDay.data[0]}/>
        }


        <div className={classNames(styles.layoutInner, {
          [styles.layoutInnerSmm]: smm
        })}>
          <div className={styles.grid}>
            { sidebar}

            <div className={styles.gridCellLayoutContentPocket34}>
              {this.props.children}
            </div>
          </div>
        </div>

        {isRegistered && !isSimpleRegs && <ul className={styles.menuMobBottom}>
          <li
            className={menuList[0].active
              ? styles.menuMobBottomItemActive
              : styles.menuMobBottomItem
            }
          >

            <Link to={'/task'} className={styles.menuMobBottomItemInner}>
                <span className={styles.menuMobBottomIco}>
                  <svg className={styles.svgIcoBookMobile}>
                    <use xlinkHref="#ico-m-tasks"></use>
                  </svg>
                </span>
              <span className={styles.menuMobBottomTitle}>Задания</span>
            </Link>
          </li>
          <li
            className={menuList[2].active
              ? styles.menuMobBottomItemActive
              : styles.menuMobBottomItem
            }
          >

            <Link to={'/food'} className={styles.menuMobBottomItemInner}>
              <span className={styles.menuMobBottomIco}>
                <svg className={styles.svgIcoFoodMobile}>
                  <use xlinkHref="#ico-m-food"></use>
                </svg>
              </span>
              <span className={styles.menuMobBottomTitle}>Питание</span>
            </Link>

          </li>
          <li
            className={menuList[5].active
              ? styles.menuMobBottomItemActive
              : styles.menuMobBottomItem
            }
          >
            <Link to={'/chats'} className={styles.menuMobBottomItemInner}>
                  <span className={styles.menuMobBottomIco}>
                    <svg className={styles.svgIcoPhoto}>
                      <use xlinkHref="#ico-chat"></use>
                    </svg>
                  </span>
              <span className={styles.menuMobBottomTitle}>Чат</span>
            </Link>
          </li>
          <li
            className={menuList[4].active
              ? styles.menuMobBottomItemActive
              : styles.menuMobBottomItem
            }
          >
            <Link to={'/reports'} className={styles.menuMobBottomItemInner}>
              <span className={styles.menuMobBottomIco}>
                <svg className={styles.svgIcoBookMobile}>
                  <use xlinkHref="#ico-m-book"></use>
                </svg>
              </span>
              <span className={styles.menuMobBottomTitle}>Зачеты</span>
            </Link>
          </li>

        </ul>}
      </div>

    )
  }
}

const mapStateToProps = state => {
  const {selectedTaskDay, recivedTaskDay, chats, menuList, sign, userInfo, userToken, showMobileLeftMenu} = state

  const {
    isFetching,
    lastUpdated,
    taskDay
  } = recivedTaskDay[selectedTaskDay] || {
    isFetching: true,
    taskDay: null
  }

  return {
    menuList,
    chats,
    sign,
    showMobileLeftMenu,
    taskDay,
    selectedTaskDay,
    userInfo,
    token: userToken.token
  }
}

const mapDispatchToProps = dispatch => ({
  setTypeId: bindActionCreators(actions.setTypeId, dispatch),
  changeChatType: bindActionCreators(actions.changeChatType, dispatch),
  clearRenderChat: bindActionCreators(actions.clearRenderChat, dispatch),
  fetchTaskDayIfNeeded: bindActionCreators(actions.fetchTaskDayIfNeeded, dispatch),
  setToken: bindActionCreators(actions.setToken, dispatch),
  setAuth:bindActionCreators(actions.setAuth, dispatch),
  setSimpleRegs:bindActionCreators(actions.setSimpleRegs, dispatch),
  setUserProfile:bindActionCreators(actions.setUserProfile, dispatch),
  showLeftMenu: bindActionCreators(
    () => dispatch({type: 'SHOW_LEFT_MENU', show: true}),
    dispatch
  ),
  hideLeftMenu: bindActionCreators(
    () => dispatch({type: 'SHOW_LEFT_MENU', show: false}),
    dispatch
  ),
  dispatch

})

Layout = connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout)


export default CSSModules(Layout, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/componentKit2/Layout.js